import { render, staticRenderFns } from "./areaUser.vue?vue&type=template&id=0334653c&scoped=true&"
import script from "./areaUser.vue?vue&type=script&lang=js&"
export * from "./areaUser.vue?vue&type=script&lang=js&"
import style0 from "./areaUser.vue?vue&type=style&index=0&id=0334653c&lang=less&rel=stylesheet%2Fless&scoped=true&"
import style1 from "./areaUser.vue?vue&type=style&index=1&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334653c",
  null
  
)

export default component.exports